export default __webpack_public_path__ + "static/media/Icon5_On.b2073c19.png";